<template>
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ title }}</p>
                <button class="delete" aria-label="close" @click="$emit('close')"></button>
            </header>
            <section class="modal-card-body">
                <img :src="imageUrl" :alt="title" width="100%">
                <div v-if="description">{{ description }}</div>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProductImageModal",
    props: {
        title: {
            required: true,
        },
        imageUrl: {
            required: true
        },
        description: {
            type: String,
            default: null
        }
    }
}
</script>